import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { setData } from '../../../features/mitakeSlice';
import TextField from '../../shared/TextField';
import { color } from '../../../app/theme';
import { MitakeAccountType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {},
    header: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$13,
      margin: '0 0 64px 0',
      '& > a': {
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: color.$2,
        textDecoration: 'underline',
      },
    },
    text: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$11,
      marginBottom: 12,
      maxWidth: 676,
      '& > a': {
        color: color.$2,
      },
    },
    title: {
      fontSize: '20px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 12,
    },
    input: {
      width: 676,
      marginBottom: 12,
    },
    hr: {
      margin: '24px 0',
    },
    option: {
      marginRight: 12,
      marginBottom: 12,
    },
    radioInput: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$13,
    },
  },
  {
    name: 'TokenContainer',
  },
);

const TokenContainer = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, isSaved } = useSelector(store => store.mitake);
  const { username, password, type } = data || {};

  const handleUsernameChange = e => {
    dispatch(
      setData({
        username: e?.target?.value,
      }),
    );
  };

  const handlePasswordChange = e => {
    dispatch(
      setData({
        password: e?.target?.value,
      }),
    );
  };

  const handleTypeChange = e => {
    dispatch(
      setData({
        type: e?.target?.value,
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {t('mitake:connect')}
        <a
          href={t('mitake:helpUrl')}
          rel="noopener noreferrer"
          target="_blank"
          className="link"
        >
          {t('mitake:help')}
        </a>
      </div>
      <div className={classes.text}>{t('mitake:connect-text1')}</div>
      <div className={classes.title}>{t('mitake:connect-account')}</div>
      <div className={classes.text}>
        {t('mitake:connect-text2-1')}
        <a
          href={t('mitake:mitakeUrl')}
          rel="noopener noreferrer"
          target="_blank"
          className="link"
        >
          {t('mitake:mitakeUrl-text')}
        </a>
        {t('mitake:connect-text2-2')}
      </div>
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="default-display"
          name="default-display"
          value={type}
          onChange={handleTypeChange}
        >
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value={MitakeAccountType.B2C}
            control={<Radio color="primary" />}
            label={t('mitake:b2c')}
          />
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value={MitakeAccountType.B2B}
            control={<Radio color="primary" />}
            label={t('mitake:b2b')}
          />
        </RadioGroup>
      </FormControl>
      <TextField
        className={classes.input}
        type="text"
        isValid
        value={username}
        placeholder={t('mitake:connect-account-placeholder')}
        onChange={handleUsernameChange}
        isError={isSaved && !username}
      />
      <hr className={classes.hr} />
      <div className={classes.text}>{t('mitake:connect-text3')}</div>
      <div className={classes.title}>{t('mitake:connect-password')}</div>
      <div className={classes.text}>{t('mitake:connect-text4')}</div>
      <TextField
        className={classes.input}
        type="text"
        isValid
        value={password}
        placeholder={t('mitake:connect-password-placeholder')}
        onChange={handlePasswordChange}
        isError={isSaved && !password}
      />
      <div className={classes.text}>{t('mitake:connect-text5')}</div>
    </div>
  );
};

export default TokenContainer;
